import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';
import { MultimediaResponse } from '@web/shared/module/multimedia';
import { PublicBoxCharacteristicResponse } from './public-box-characteristic.response';
import { PublicSalesResponse } from '@web/shared/module/shop';
import { PublicBoxComponentGroupResponse } from './public-box-component-group.response';

@jsonObject
export class PublicBoxDetailsResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly slug!: string;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(Number)
  public readonly price!: number;

  @jsonMember(String)
  public readonly contentPreviewUrl!: string;

  @jsonMember(PublicSalesResponse)
  public readonly sales!: PublicSalesResponse;

  @jsonMember(MultimediaResponse)
  public readonly symbol!: MultimediaResponse;

  @jsonMember(MultimediaResponse)
  public readonly illustration!: MultimediaResponse;

  @jsonArrayMember(PublicBoxCharacteristicResponse)
  public readonly characteristics!: PublicBoxCharacteristicResponse[];

  @jsonArrayMember(PublicBoxComponentGroupResponse)
  public readonly groups?: PublicBoxComponentGroupResponse[];

  @jsonArrayMember(MultimediaResponse)
  public readonly galleryFiles!: MultimediaResponse[];
}
